import React from 'react'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'
import styled from 'styled-components'
import { breakpoint } from 'src/theme/grid'

import Pagination from 'src/components/Pagination'

import {
  BottomRow,
  Container,
  Counter,
  Ellipsis,
  EmptyOffers,
  RefreshIcon,
  Row
} from 'src/features/stocks/components/atoms'
import LoadingList from 'src/components/atoms/LoadingList'

import Shade from 'src/components/Shade'
import {
  ActionGroup,
  HeaderItem,
  Padding
} from 'src/features/myOffers/components/atoms'
import { Icon, SectionBox } from 'src/features/account/components/atoms'
import ArrowIcon from 'src/assets/icons/arrow-down.svg'
import { connectMyContractsReservationsFinished } from 'src/features/contracts/duck/connectors'
import {
  CONTRACTS_HEADERS,
  CONTRACTS_HEADERS_MY_RESERVATIONS_FINISHED_NAMES,
  CONTRACTS_HEADERS_MY_RESERVATIONS_FINISHED_WIDTHS
} from 'src/features/contracts/duck/consts'
import { TableHeader } from 'src/features/contracts/components/atoms'
import Checkbox from 'src/components/atoms/CheckboxInput'
import { BOOLEAN } from 'src/ducks/consts'
import ReservationRowFinished from 'src/features/contracts/components/ReservationRowFinished'
import { isStockLoading } from 'src/utils/stocks'

const OffersList = ({
  finishedReservations,
  offers,
  pagination,
  filters,
  setFilter,
  hidePagination = false,
  getFinishedReservations,
  showOffer,
  className
}) => {
  const headers = CONTRACTS_HEADERS.MY_RESERVATIONS_FINISHED
  const intl = useIntl()

  const handleOfferClick = id => {
    showOffer(id)
  }

  const toggleFilter = name => {
    setFilter(name, !filters.onlyMe)
  }

  const renderListContents = () => {
    if (isStockLoading(finishedReservations, 'list')) {
      return (
        <>
          <Shade />
          <LoadingList />
        </>
      )
    }

    if (offers.length === 0) {
      return (
        <EmptyOffers>
          <FormattedMessage id='offers.noOffers' />
        </EmptyOffers>
      )
    }

    if (offers.length > 0) {
      return offers.map(reservation => (
        <ReservationRowFinished
          offer={reservation.offer}
          reservation={reservation}
          handleClick={handleOfferClick}
          key={reservation.id}
        />
      ))
    }
  }

  return (
    <div className={className}>
      <Padding></Padding>
      <ListTopRow>
        <CounterGroup>
          <Counter>
            <span>{`${pagination.total} `}</span>
            <FormattedMessage
              id='offers.offersFound'
              values={{
                count: pagination.total
              }}
            />
          </Counter>
          <RefreshIcon onClick={getFinishedReservations} />
        </CounterGroup>
        <ActionGroup>
          <Checkbox
            name='onlyMe'
            value={filters.onlyMe}
            onChange={toggleFilter}
            option={{
              text: intl.formatMessage({ id: 'offers.onlyMe' }),
              value: BOOLEAN.YES
            }}
          />
        </ActionGroup>
      </ListTopRow>
      <Container>
        <TableHeader
          widths={CONTRACTS_HEADERS_MY_RESERVATIONS_FINISHED_WIDTHS}
          columnNames={CONTRACTS_HEADERS_MY_RESERVATIONS_FINISHED_NAMES}
        >
          {headers &&
            headers.map((header, index) => (
              <HeaderItem sort={false} key={`${header.name} ${index}`}>
                <Ellipsis>
                  <FormattedMessage
                    id={`stocksHeaders.${header.name}`}
                    defaultMessage=' '
                  />
                  {header.sort && (
                    <Icon>
                      <ArrowIcon />
                    </Icon>
                  )}
                </Ellipsis>
              </HeaderItem>
            ))}
        </TableHeader>
        {renderListContents()}
      </Container>
      {offers.length > 0 && !hidePagination && (
        <BottomRow>
          <Pagination
            itemsPerPage={filters.limit}
            currentPage={pagination.currentPage}
            pagesCount={pagination.lastPage}
            setPage={page => setFilter('page', page)}
            setItemsPerPage={limit => {
              setFilter('limit', limit)
              setFilter('page', 1)
            }}
          />
        </BottomRow>
      )}
    </div>
  )
}

const connectedComponent = connectMyContractsReservationsFinished(OffersList)
export default styled(connectedComponent)`
  ${SectionBox} {
    padding: 0 0 180px 0;
    ${breakpoint.m`
      padding: 0 1.2rem 180px 1.2rem;
  `}
  }
`
export const ListTopRow = styled(Row)`
  justify-content: space-between;
  padding: 0 1.2rem;
  ${Counter} {
    margin-right: 0.75rem;
  }
  ${breakpoint.m`
     padding: 0;
  `}
`
const CounterGroup = styled.div`
  display: flex;
`
